import { Link } from "react-router-dom";

export const Logo = ({ to = "/", compact = false, narrow = false }) => (
  <Link to={to} data-testid="logo-link" className="flex items-center gap-2 group">
    <img src="/logo-mark.png?v=6" alt="itzPlay" className="w-9 h-9 rounded-xl shadow-sm transition-transform duration-300 group-hover:rotate-6" />
    <span className={`font-display font-extrabold text-xl tracking-tight ${compact ? "hidden sm:inline" : narrow ? "hidden min-[430px]:inline" : "hidden min-[360px]:inline"}`}>
      itz<span className="text-rose-500">Play</span>
    </span>
  </Link>
);
